import * as Toggle from '@radix-ui/react-toggle-group'
import { PermissionsGate } from 'features/permissions'
import React from 'react'
import styled from 'styled-components'
import { ThemeMode, useGeckoTheme } from 'styles/GeckoTheme'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

const StyledContainer = styled.div`
  padding: 0.5rem 1rem;
  width: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
`

const StyledToggleRoot = styled(Toggle.Root)`
  all: unset;
  display: inline-flex;
  background-color: ${({ theme }) => theme.forecast.background2};
  border-radius: 0.25rem;
  height: 33px;
  margin-bottom: -14px;
  overflow-x: scroll;
`
const StyledToggleItem = styled(Toggle.Item)`
  all: unset;
  color: ${({ theme }) => theme.forecast.text4};
  background-color: ${({ theme }) => theme.forecast.background3};
  height: 1.4rem;
  width: 4rem;
  min-width: 2.5rem;
  padding: 0 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-size: 0.675rem;
  text-wrap: nowrap;

  &:hover {
    color: ${({ theme }) => theme.forecast.text2} !important;
    background-color: ${({ theme }) => theme.forecast.background4};
    cursor: pointer;
    font-weight: bold;
    letter-spacing: -0.3px;
  }

  &:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  &:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }

  &[data-state='on'] {
    color: ${({ theme }) => theme.forecast.text1} !important;
    background-color: ${({ theme }) => theme.forecast.background4} !important;
  }

  &:focus {
    background-color: ${({ theme }) => theme.forecast.background4} !important;
  }
`

const StyledToggleItemBratRemix = styled(StyledToggleItem)`
  text-wrap: wrap;
  width: 128px;
  line-height: 11px;
  flex-shrink: 0;
`

export const ThemeModeToggle: React.FC = () => {
  const { themeMode, setThemeMode } = useGeckoTheme()
  return (
    <StyledContainer>
      Theme
      <StyledToggleRoot
        type='single'
        value={themeMode}
        aria-label='Set Theme'
        onClick={(event) => event.stopPropagation()}
        onValueChange={(value) => {
          setThemeMode(ThemeMode[value as keyof typeof ThemeMode])
        }}>
        <StyledToggleItem value='Dark'>Dark</StyledToggleItem>
        <StyledToggleItem value='Light'>Light</StyledToggleItem>
        <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
          <StyledToggleItem value='Spooky'>Spooky</StyledToggleItem>
          <StyledToggleItem value='HotDog'>Hot Dog</StyledToggleItem>
          <StyledToggleItem value='Barbie'>Barbie</StyledToggleItem>
          <StyledToggleItem value='Brat'>Brat</StyledToggleItem>
          <StyledToggleItemBratRemix value='BratRemix'>
            Brat and it&apos;s completely different but also still brat
          </StyledToggleItemBratRemix>
        </PermissionsGate>
      </StyledToggleRoot>
    </StyledContainer>
  )
}
